module.exports = "<div mk-morris-js [options]=\"chartDonutOptions\" [data]=\"chartDonutData\" type=\"Donut\"></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/component/donut-chart/donut-chart.component.html
// module id = ./src/app/shared/component/donut-chart/donut-chart.component.html
// module chunks = main